import * as React from 'react';
import * as _ from 'lodash';
import { ViewCategoryContainer, ViewCategorySection, ViewCategorySubtitle, ViewCategoryList, ViewCategoryLabel, NewCategoryHolder } from './styles';
import { DealerEngineCategories } from 'features/Dealers/Listings/Categories/state/types';
import { ListEditor } from 'components/ListEditor';
import CategorySelect from 'features/Dealers/Listings/Categories/CategorySelect';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { serviceLoading } from 'common/loaderReducer';
import { RootState } from 'store/types';
import { GET_ENGINECATEGORY_API_REQUEST, GET_LMCATEGORIES_API_REQUEST } from 'features/Dealers/Listings/Categories/state/actionTypes';
import { DEFAULT_PAGE_SIZE } from './state/constants';
import { categoryLoadMore, editEngineCategorySearchQuery, getEngineCategoryAPI } from 'features/Dealers/Listings/Categories/state/actions';
import { displayPartsToString } from 'typescript';


export interface EditCategoriesProps {
    categories: DealerEngineCategories
    onCategoriesChange: (categories: DealerEngineCategories) => void
}


const EditCategories = (props: EditCategoriesProps) => {

    const dispatch = useDispatch();

    const [categoriesQueries, setCategoriesQueries] = React.useState("");

    const {
        isLoading,
        categories,
        liveCategories,
        isLoadingCategories,
        allCategories,
        dealerId,
        lastPageSize,
        page,
        limit,
        countryData
    } = useSelector((rootState: RootState) => {
        return {
            isLoading: serviceLoading(rootState, [GET_LMCATEGORIES_API_REQUEST]),
            isLoadingCategories: serviceLoading(rootState, [GET_ENGINECATEGORY_API_REQUEST]),
            liveCategories: rootState.dealers.listing.currentListing.categories.liveDealerCategories,
            categories: rootState.dealers.listing.currentListing.categories.originalDealerCategories,
            allCategories: rootState.dealers.listing.currentListing.categories.enginecategories,
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            page: rootState.dealers.listing.currentListing.categories.page,
            limit: rootState.dealers.listing.currentListing.categories.limit,
            lastPageSize: rootState.dealers.listing.currentListing.categories.lastPageSize ?? DEFAULT_PAGE_SIZE,
            countryData: rootState.dealers.enginedealer.countryData
        }
    }, shallowEqual);

    React.useEffect(() => {            
            dispatch(getEngineCategoryAPI("GMB", countryData?.countryCode ?? "", countryData?.languageCode??"en-US", page, limit, categoriesQueries === "" ? undefined : categoriesQueries)); //English is Default
    }, [page, categoriesQueries])

    

    return (
        <ViewCategoryContainer>
            <ViewCategorySection>
                <ViewCategorySubtitle>
                    {
                        "Primary Category"
                    }
                </ViewCategorySubtitle>
                <ListEditor
                    onActionClick={(a, b) => { }}
                >

                    <CategorySelect
                        categories={allCategories}
                        page={page}
                        limit={limit}
                        isLoadingCategories={isLoadingCategories}
                        lastPageSize={lastPageSize}
                        query={categoriesQueries}
                        selectedCategory={props.categories.primaryCategory}
                        onQueryChange={
                            (qv) => onPrimaryCategoryQueryChange("PRI_CAT", qv)
                        }
                        loadCategories={onCategoryLoadMore}
                        onCategorySelected={onPrimaryCategorySelected}

                    />
                </ListEditor>
            </ViewCategorySection>
            <ViewCategorySection>
                <ViewCategorySubtitle>
                    {
                        "Additional Categories"
                    }
                </ViewCategorySubtitle>
                <ListEditor
                    onActionClick={onCateogoryActionClick}
                >
                    {
                        props.categories.additionalCategories.map((ac, idx) => {
                            return (
                                <CategorySelect
                                    categories={allCategories}
                                    page={page}
                                    limit={limit}
                                    isLoadingCategories={isLoadingCategories}
                                    lastPageSize={lastPageSize}
                                    query={categoriesQueries}
                                    selectedCategory={ac}
                                    onQueryChange={
                                        (qv) => onAdditionalCategoryQueryChange(`${idx}`, qv)
                                    }
                                    loadCategories={onCategoryLoadMore}
                                    onCategorySelected={(c) => onAdditionalCategorySelected(idx, c)}
                                />
                            )
                        })
                    }
                </ListEditor>
                <NewCategoryHolder>
                    <CategorySelect
                        categories={allCategories}
                        page={page}
                        limit={limit}
                        isLoadingCategories={isLoadingCategories}
                        lastPageSize={lastPageSize}
                        query={categoriesQueries}
                        selectedCategory={undefined}
                        onQueryChange={
                            (qv) => onAdditionalCategoryQueryChange(`NEW`, qv)
                        }
                        loadCategories={onCategoryLoadMore}
                        onCategorySelected={(c) => onNewAdditionalCategorySelected(c)}

                    />
                </NewCategoryHolder>

            </ViewCategorySection>
        </ViewCategoryContainer>
    )

    function onPrimaryCategoryQueryChange(id, qv) {        
        dispatch(editEngineCategorySearchQuery(qv))
        setCategoriesQueries(qv)
    }

    function onCategoryLoadMore() {
        dispatch(categoryLoadMore())
    }

    function onPrimaryCategorySelected(category) {
        const liveCategories = { ...props.categories };
        liveCategories.primaryCategory = category
        props.onCategoriesChange(liveCategories)
    }

    function onAdditionalCategoryQueryChange(id, qv) {
        dispatch(editEngineCategorySearchQuery(qv))
        setCategoriesQueries(qv)
    }

    function onAdditionalCategorySelected(idx, category) {
        const liveCategories = { ...props.categories };
        liveCategories.additionalCategories[idx] = category
        props.onCategoriesChange(liveCategories)
    }

    function onCateogoryActionClick(id, event) {
        const liveCategories = { ...props.categories };
        liveCategories.additionalCategories.splice(id, 1);
        props.onCategoriesChange(liveCategories);
    }

    function onNewAdditionalCategorySelected(category) {
        const liveCategories = { ...props.categories };
        liveCategories.additionalCategories.push(category)
        props.onCategoriesChange(liveCategories)
    }
}

export default EditCategories